// @flow

const listWithBullets = (list: string[]): string => list.map(item => `• ${item}`).join('\n');

export default listWithBullets;
